.die {
    display: block;
    overflow: visible;
    fill: var(--die-fill, transparent);
    stroke: var(--die-color);
    stroke-width: var(--die-width);
}
